import { render, staticRenderFns } from "./BuscarPedidoUnidadeCargaTrecho.vue?vue&type=template&id=eff10804"
import script from "./BuscarPedidoUnidadeCargaTrecho.vue?vue&type=script&lang=js"
export * from "./BuscarPedidoUnidadeCargaTrecho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports